import { Link, generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { FeatureIslandContainer, FeatureIslandMainWithBackGround } from "@/components/features/_layouts";
import { PlanHeaderAndTabs } from "@/components/features/items/_components";

import { Button } from "@/components/ui/button/button";

import { useGetPlanStockDeprecatedPageParams } from "./_hooks/use-get-plan-stock-deprecated-page-params";

export const PlanStockDeprecatedPage = () => {
	const { hotelID } = useGetPlanStockDeprecatedPageParams();

	return (
		<PageMeta title="日ごとの在庫管理" url={generatePath(PATHS.HOTEL.ITEMS.PLAN.STOCK_DEPRECATED, { hotelID })}>
			<div>
				<FeatureIslandContainer>
					<PlanHeaderAndTabs
						hotelID={hotelID}
						headerProps={{
							title: "日ごとの在庫管理",
						}}
					/>

					<FeatureIslandMainWithBackGround>
						{/* ナッジ導線: サイドメニューへの案内 */}
						<div className="flex flex-col items-center gap-6 py-12">
							<div className="space-y-2 text-center">
								<p className="text-lg font-semibold">この機能は移動しました</p>
								<p className="text-sm text-caption-50">
									日ごとの在庫管理はサイドメニューの「在庫管理」からアクセスできます。
								</p>
							</div>
							<Link to={generatePath(PATHS.HOTEL.ITEMS.PLAN.STOCK, { hotelID })}>
								<Button type="button" size="xl">
									在庫管理へ移動
								</Button>
							</Link>
						</div>
					</FeatureIslandMainWithBackGround>
				</FeatureIslandContainer>
			</div>
		</PageMeta>
	);
};

PlanStockDeprecatedPage.displayName = "PlanStockDeprecatedPage";
